import { DateTime } from "luxon";

/**
 * Convert number to letter (1->A, 2->B, etc.)
 */
export const numToLetter = (num) => {
  let s = "",
    t;
  while (num > 0) {
    t = (num - 1) % 26;
    s = String.fromCharCode(65 + t) + s;
    num = ((num - t) / 26) | 0;
  }
  return s || undefined;
};

/**
 * Add ordinal suffix to numbers (1st, 2nd, 3rd, etc.)
 */
export const addOrdinalSuffix = (n) => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return s[(v - 20) % 10] || s[v] || s[0];
};

/**
 * Parse due date into formatted string
 */
export const parseDueDate = (dueDate) => {
  if (!dueDate) return "7am Sydney Time";
  const dateObject = DateTime.fromISO(dueDate).setZone("Australia/Sydney");
  const formattedDay = addOrdinalSuffix(dateObject.day);
  const formattedDate = dateObject.toFormat(`EEEE d'${formattedDay} 'MMMM`);
  return `${formattedDate}, 7am Sydney Time`;
};

/**
 * Parse line items into formatted string for email
 */
export const parseLineItems = (lineItems, outsourcerData) => {
  let linesData = "";
  lineItems?.forEach((line, index) => {
    let tmp;
    if (outsourcerData.companyName === "OMMS") {
      tmp = `${index + 1}. ${line.type} = ${line.images}\n\n`;
    } else {
      tmp = `${index + 1}. ${line.type} = ${line.images} @ $${line.price}\n\n`;
    }
    linesData = linesData + tmp;
  });
  return linesData;
};

/**
 * Calculate total cost from line items
 */
export const parseTotal = (lineItems) => {
  let total = 0;
  lineItems?.forEach((line) => {
    let linePrice = parseInt(line.images) * parseFloat(line.price);
    total = total + linePrice;
  });
  return `$${parseFloat(total).toFixed(2)} AUD`;
};

/**
 * Generate brief buttons HTML for email template
 */
export const makeBriefButtons = (briefs) => {
  if (!briefs || briefs.length === 0) return "";

  let tmp = `

<div class="instructions-text" style="text-align: center;">
<strong>INSTRUCTIONS:</strong>
</div>

`;

  briefs.forEach((brief, index) => {
    if (brief.name && brief.url) {
      // Escape the brief name to prevent HTML issues
      const escapedName = brief.name.replace(/[<>&"']/g, (match) => {
        const escapeMap = {
          "<": "&lt;",
          ">": "&gt;",
          "&": "&amp;",
          '"': "&quot;",
          "'": "&#39;",
        };
        return escapeMap[match];
      });

      // Properly encode the URL for HTML attributes
      const escapedUrl = brief.url.replace(/&/g, "&amp;").replace(/_/g, "%5F");

      tmp += `<div style="text-align: center;">
<a href="${escapedUrl}" class="outsourcer-button" target="_blank">
  <span style="text-transform: uppercase;">${escapedName}</span>
</a>
</div>${index < briefs.length - 1 ? "<br>" : ""}`;
    }
  });

  return tmp;
};

/**
 * Generate job details button for outsourcer page
 */
export const makeJobDetailsButton = (
  jobData,
  hasRetouchingNotes,
  hasColourChanges
) => {
  let buttonLabel;
  if (hasRetouchingNotes && hasColourChanges) {
    buttonLabel = "Retouching Notes & Colour Changes";
  } else if (hasRetouchingNotes && !hasColourChanges) {
    buttonLabel = "Retouching Notes";
  } else if (!hasRetouchingNotes && hasColourChanges) {
    buttonLabel = "Colour Changes";
  } else {
    buttonLabel = "Job Details";
  }

  const buttonBgColor = "#000000"; // Always black like supply email

  return {
    label: buttonLabel,
    url: `https://staff.imagesthatsell.com.au/outsourcerjob/${jobData.id}`,
    backgroundColor: buttonBgColor,
  };
};

/**
 * Get job name from job data
 */
export const getJobName = (jobData) => {
  return `${jobData.jobNumber}-${jobData.client}${
    jobData.multipleDays ? `-${jobData.multipleDays}` : ""
  }${jobData.jobTypeShort}`;
};
